import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { retrieveToken } from "@/services/AuthService";
import store from "../vuex/store";

export async function startQaplaSession() {
  const oauthQaplaCredentials = await obtainSSOTokenFromHub(
    "/oauth/qapla-token"
  );

  const headers = {
    "Content-type": "application/x-www-form-urlencoded"
  };

  const config = {
    method: "POST",
    withCredentials: true,
    url: getBaseApiQaplaUrl() + "/auth/start-session",
    data: {
      access_token: oauthQaplaCredentials.access_token,
      refresh_token: oauthQaplaCredentials.refresh_token,
      paperless:
        store.getters.features.storePaperlessEnabled &&
        !store.getters["customer/config"].disablePaperlessFeature,
      qaplaLevel: store.getters.features.qapla.qaplaLevel,
      storeCode: store.getters["customer/storeInfo"].store.storeCode
    },
    headers: headers
  } as AxiosRequestConfig;
  try {
    const resp = await axios.create().request(config);
    return resp.data;
  } catch (err) {
    console.error("Response failed with message: " + err.response.data.message);
    return Promise.reject(err.response.data);
  }
}

async function obtainSSOTokenFromHub(path: string) {
  const config = {
    url: store.getters.BASE_API_URL + path,
    method: "GET",
    headers: {
      Authorization: "Bearer " + retrieveToken().access_token
    }
  } as AxiosRequestConfig;
  try {
    const res = (await axios.request(config)) as AxiosResponse<{
      access_token: string;
      refresh_token: string;
    }>;
    return res.data;
  } catch (err) {
    console.error("Response failed with message: " + err.response.data.message);
    return Promise.reject(err.response.data);
  }
}

function getBaseApiQaplaUrl() {
  let baseQaplaUrl = "";
  if (store.getters.envs.isLocal) {
    baseQaplaUrl = "https://dev-cp.eship.mbeglobal.com";
  }
  if (store.getters.envs.isDevelopment) {
    baseQaplaUrl = "https://dev-cp.eship.mbeglobal.com";
  }
  if (store.getters.envs.isPreProduction || store.getters.envs.isIntegration) {
    baseQaplaUrl = "https://staging-cp.eship.mbeglobal.com";
  }
  if (store.getters.envs.isProduction) {
    baseQaplaUrl = "https://eship.mbeglobal.com";
  }
  return baseQaplaUrl;
}
